import type { FaireProductEntity } from "../../entity_types/product";

export const p_bqqmmwvhh9: FaireProductEntity = {
  token: "p_bqqmmwvhh9",
  type: "product",
  name: "John Derian Wrapping Paper Book II",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/7b7ed700fb2d2f686202514a284fa394d489d3f22937b2cf37599c4e145f19ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/237fc33d5d5682210fcdbbd0905cd873d2a060fd00464e45736e565668014550.png"
  ],
  priceDollars: 10,
  description: "A collection of 12 stunning wrapping paper sheets and matching sticker tags from beloved home goods designer and New York Times bestselling author John Derian. World-renowned designer, artist, and author John Derian returns with yet another gorgeous and interactive book. Featuring a curated collection of his most-loved images, including florals, seashells, constellations, and antique wallpaper patterns, John Derian Wrapping Paper Book II includes 12 perforated sheets that detach and unfold to 18 7/8 x 25 3/4 inches, along with one page of sticker tags. These wrapping paper sheets turn every present into a work of art, adding that special touch to gifts for any occasion, from holidays to birthdays and every celebration in between.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:20.977Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
